<template>
	<v-card width="1142" class="mx-auto mt-12">
		<v-banner sticky="true">
			<TopBar/>
		<v-tabs
			fixed-tabs
			slider-size="5"
			class="main-tabs">
			<v-tab
				to="/">
				Start
			</v-tab>
			<v-tab
				to="angebote">
				Leistungsangebote
			</v-tab>
			<v-tab
				to="career">
				Jobangebote
			</v-tab>
			<v-menu
				open-on-hover
				bottom
				offset-y
				v-model="unternehmen"
				ref="unternehmen">
				<template v-slot:activator="{ on }">
					<v-tab
						v-on="on"
						to="unternehmen">
						Unternehmen
					</v-tab>
				</template>
				<v-card
					to="unternehmen"
					class="pa-3">Über uns</v-card>
				<v-card
					to="/arbeiten-bei-manitz-it"
					class="pa-3">Arbeiten bei MANITZ IT</v-card>
			</v-menu>
			<v-menu
				open-on-hover
				bottom
				offset-y
				v-model="impressum"
				ref="impressum">
				<template v-slot:activator="{ on }">
					<v-tab
						v-on="on"
						to="impressum">
						Impressum
					</v-tab>
				</template>
				<v-card
					to="/datenschutz"
					class="pa-3">Datenschutz</v-card>
			</v-menu>
		</v-tabs>
		</v-banner>
		<router-view></router-view>
		<MainFooter></MainFooter>
	</v-card>
</template>

<script>
import TopBar from "./widgets/TopBar.vue";
import MainFooter from "./widgets/MainFooter.vue";
	
	export default {
		name: "ManitzMain",
		
		components: {
			TopBar,
			MainFooter,
		},
		
		data: function() {
			return {
				tooltip: false,
			}
		}
	}

</script>

<style scoped>
.main-tabs >>> .v-slide-group .v-tabs-slider-wrapper {
	top: 0;
	bottom: auto;
	border-bottom: 1px solid;
}
</style>